export default "__VITE_ASSET__CFGTOMGm__"